import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LRS_ACTIONS, TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP } from '@techchange/components';

const propTypes = {

	/**
	 * The video id.
	 */
	id: PropTypes.string.isRequired,

	/**
	 * The video url.
	 */
	src: PropTypes.string.isRequired,

	/**
	 * The aspect ratio for the video.
	 */
	aspectRatio: PropTypes.string,

	/**
	 * The video title.
	 */
	title: PropTypes.string.isRequired,

	/**
	 * Function to handle video watching.
	 */
	onVideoWatch: PropTypes.func.isRequired,

};

const defaultProps = {
	aspectRatio: TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP,
};

class IframeMicrosoftPlayer extends Component {

	constructor(props) {
		super(props);

		this.handleReceiveMessage = this.handleReceiveMessage.bind(this);
	}

	componentDidMount() {
		window.addEventListener('message', this.handleReceiveMessage);
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.handleReceiveMessage);
	}

	handleReceiveMessage(event) {

		// Only support embedded Microsoft assets

		// Also bail if event data isn't a JSON string. The first message sent from the MS iframe
		// is a standard object, not JSON string.
		if (event.origin !== 'https://www.microsoft.com' || typeof event.data !== 'string') {
			return;
		}

		let data;

		try {
			data = JSON.parse(event.data);
		} catch (err) {
			console.error('Error parsing JSON data for Microsoft video');
		}

		if (!data) {
			console.error('Data empty');
			return;
		}

		// Shortcut for the event object's own data object
		if (data.data) {
			data = data.data;
		} else {
			return;
		}

		let status;

		// Determine the status of the video
		switch (data.behavior) {
		case 240:
			status = LRS_ACTIONS.PLAYED;
			console.log('Played video (initial play only)');
			break;
		case 241:
			status = LRS_ACTIONS.PAUSED;
			console.log('Paused video');
			break;
		case 242:
			status = LRS_ACTIONS.PLAYED;
			console.log('Resumed video');
			break;
		case 243:
			console.log('Playing video');
			break;
		case 244:
			console.log('Completed video (244)');
			break;
		case 245:
			status = LRS_ACTIONS.FINISHED;
			console.log('Completed video (245)');
			break;
		case 253:
			console.log('Loaded video');
			break;
		default:
			console.log('Unexpected command: ', data.behavior);
		}

		const contentTags = data.contentTags;

		console.log('Title: ', contentTags.vidnm);
		// console.log('Cover image: ', data.pageTags.videoObj.vmetadata.posterframeUrl);
		// console.log('Percent completed: ', contentTags.vidpct);
		// console.log('Percent watched this session: ', contentTags.vidpctwtchd);
		// console.log('Video watched (seconds): ', contentTags.vidwt);
		// console.log('Total video duration: ', contentTags.viddur);
		// console.log('Video watched this session: ', contentTags.vidtimeseconds);
		// console.log('Total video watching session duration: ', contentTags.sessiontimeseconds);

		const { id, onVideoWatch } = this.props;

		// Check if the status of the video requires a callback action
		if (status && onVideoWatch) {

			const currentTime = contentTags.vidwt;
			const totalTime = contentTags.viddur;

			const metadata = {
				id,
				status,
				currentTime,
				totalTime,
				event,
			};

			onVideoWatch(metadata);

		}

	}

	render() {

		const { src, aspectRatio, title } = this.props;

		return (
			<div className={`ratio ratio-${aspectRatio}`}>
				<iframe
					src={src}
					title={title}
					frameBorder="0"
					allowFullScreen />
			</div>
		);
	}
}

IframeMicrosoftPlayer.propTypes = propTypes;
IframeMicrosoftPlayer.defaultProps = defaultProps;

export default IframeMicrosoftPlayer;
